import * as React from 'react'

import { BrandsPage } from '@thg-commerce/enterprise-components'
import { IndexedBrandsPageWidget } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Types/BrandsPageWidget'

import { BaseWidgetProps } from '../types'

type BrandsPageWidgetRendererProps = BaseWidgetProps & {
  brands: IndexedBrandsPageWidget
}

export const BrandsPageWidgetRenderer: React.FunctionComponent<BrandsPageWidgetRendererProps> = (
  props,
) => {
  return <BrandsPage brands={props.brands} />
}
